/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelFormCheckbox64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelFormCheckbox64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M22 25C22 23.3431 23.3431 22 25 22H39C40.6569 22 42 23.3431 42 25V39C42 40.6569 40.6569 42 39 42H25C23.3431 42 22 40.6569 22 39V25Z"
            fill="currentColor"
          />
          <g>
            <path
              d="M30.9417 34.9425L37.4415 28.4419L36.5576 27.5581L30.4997 33.6166L27.4416 30.5581L26.5576 31.4419L30.0578 34.9425C30.175 35.0597 30.334 35.1255 30.4997 35.1255C30.6655 35.1255 30.8245 35.0597 30.9417 34.9425Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22 25C22 23.3431 23.3431 22 25 22H39C40.6569 22 42 23.3431 42 25V39C42 40.6569 40.6569 42 39 42H25C23.3431 42 22 40.6569 22 39V25ZM25 23H39C40.1046 23 41 23.8954 41 25V39C41 40.1046 40.1046 41 39 41H25C23.8954 41 23 40.1046 23 39V25C23 23.8954 23.8954 23 25 23Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelFormCheckbox64Icon.tags = [
  'checkbox',
  'form',
  'select',
  'empty',
  'option',
];

AddPanelFormCheckbox64Icon.category = '64x64 (Add panel)';

AddPanelFormCheckbox64Icon.iconSize = 64;
